//General currency name. Use it when you want to show currency word
const currencyName = "تومان"

export enum StaticTextEnum {
    sendTicket = "ارسال تیکت",
    sellers = "فروشندگان",
    OrderHistory = "تاریخچه سفارشات",
    myOrder = " سفارش های من",
    price = "مبلغ",
    orderNumber = "شماره سفارش",
    orderDate = "تاریخ سفارش",
    orderDetail = "جزییات سفارش",
    amountPayable = "مبلغ قابل پرداخت",
    paymentMethod = "روش پرداخت",
    bankGetWay = "درگاه بانکی",
    Installment = "قسطی",
    toman = currencyName,
    month = "ماه",
    selectedFile = "فایل انتخاب شده",
    count = "تعداد",
    cancelOrder = "لغو سفارش",
    fullName = "نام و نام خانوادگی",
    receiver = "گیرنده",
    receiverMobile = "شماره گیرنده",
    address = "آدرس",
    shippingMethod = "شیوه ارسال",
    regularShipping = "ارسال معمولی",
    scheduledSending = "ارسال زمانبندی شده",
    shippingCost = "هزینه ارسال",
    free = "رایگان",
    reOrder = " سفارش مجدد",
    trackingCode = "کد پیگیری مرسوله",
    orderStatus = "وضیعت سفارش",
    pay = "پرداخت",
    Preparation = " اماده سازی",
    sent = "ارسال شده",
    wallet = "کیف پول",
    waiting = "لطفا صبر کنید...",
    transactionRecords = " سوابق تراکنش",
    noTransactionsHaveBeenRecordedYet = "هنوز هیچ تراکنشی ثبت نشده است",
    yourInventory = "موجودی شما",
    settlementRequests = " درخواست های تسویه",
    lastUpdate = "آخرین به‌روزرسانی",
    status = "وضعیت",
    requestDate = "تاریخ درخواست",
    noRequestsHaveBeenFiledYet = " هنوز هیچ درخواستی ثبت نشده است",
    addressRegistration = " ثبت آدرس",
    edit = " ویرایش",
    registerNewAddress = "ثبت آدرس جدید",
    editAddress = "ویرایش آدرس",
    addresses = " ادرس ها",
    unit = "واحد",
    no = "پلاک",
    mobileNumber = "شماره موبایل",
    postal_code = "کد پستی",
    optional = "اختیاری",
    addressTitle = "عنوان ادرس",
    fullAddress = "آدرس کامل",
    choose = "انتخاب کنید",
    firstSelectTheProvince = " ابتدا استان را انتخاب کنید",
    city = "شهر",
    province = "استان",
    ownReceiver = " گیرنده خودم هستم",
    landline = " تلفن ثابت",
    delete = "حذف",
    send = "ارسال",
    youDontHaveAnyOrdersYet = "هنوز هیچ سفارشی ندادید",
    wishes = " علاقه مندی ها",
    NonExistent = "ناموجود",
    addToBasket = "افزودن به سبد خرید",
    yourWishlistIsEmpty = "لیست علاقه‌مندی‌های شما خالی است",
    yourAddressListIsEmpty = "هنوز هیچ آدرسی ثبت نکرده اید",
    notChooseAddress = "آدرسی انتخاب نشده !",
    voucherCode = "کد های تخفیف",
    youDontHaveAnyVoucherCode = "  کد تخفیف ندارید",
    discountPercent = "درصد تخفیف:",
    discountPrice = "مبلغ تخفیف:",
    isActive = "فعال",
    expired = " منقضی شده است",
    title = "عنوان",
    detailsVoucherCode = "  جزییات کد تخفیف",
    viewDetails = "مشاهده جزییات",
    expiredDate = "تاریخ انقضا",
    copied = "کپی شد",
    copy = "کپی ",
    userAccountInfo = "اطلاعات حساب کاربری",
    nationalCode = "کد ملی",
    email = "ایمیل",
    birthdayDate = " تاریخ تولد",
    password = "رمز عبور",
    passwordRecovery = "بازیابی رمز عبور",
    changePassword = "تغییر رمز عبور",
    newPassword = "رمز عبور جدید",
    repeatNewPassword = " تکرار رمز عبور جدید",
    currentPassword = "رمز عبور فعلی",
    accountInfo = " اطلاعات حساب",
    year = "سال",
    day = "روز",
    submit = "ثبت",
    approved = "تایید",
    identificationInformation = "ثبت اطلاعات شناسایی",
    bankAccountInfo = "اطلاعات حساب بانکی",
    bank = "بانک",
    accountNumber = "شماره حساب",
    ibanNumber = "شماره شبا",
    changeInfoContactUs = "اگر می‌خواهید اطلاعات حساب خود را تغییر دهید، لطفاً با تیم پشتیبانی ما تماس بگیرید",
    isForeigner = "اتباع خارجی هستم و کد ملی ندارم",
    editEmail = "ویرایش پست الکترونیکی",
    male = "مرد",
    female = "زن",
    lastName = " نام خانوادگی",
    firstName = "نام",
    gender = "جنسیت",
    youHaveNotPostedAnyCommentsYet = " هنوز هیچ نظری ثبت نکرده‌اید.",
    myOpinion = "نظرات من",
    opinions = "نظرات",
    rate = " امتیاز دهید",
    contentComment = "متن نظر",
    sendContent = "ارسال محتوا",
    maximum3Photos = " حداکثر ۳ عکس و هر کدام ۱ مگابایت با فرمت Jpeg",
    add = "افزودن",
    submitCommentAnonymously = "ارسال دیدگاه به صورت ناشناس",
    commentingRules = `لطفا پیش از ارسال دیدگاه، خلاصه قوانین زیر را مطالعه کنید:
                       
                                لازم است محتوای ارسالی منطبق برعرف و شئونات جامعه و با بیانی رسمی و عاری از لحن تند،
                                تمسخرو توهین باشد.
                          
                                از ارسال لینک‌های سایت‌های دیگر و ارایه‌ی اطلاعات شخصی خودتان مثل شماره تماس، ایمیل
                                و آی‌دی شبکه‌های اجتماعی پرهیز کنید.
                
                                در نظر داشته باشید هدف نهایی از ارائه‌ی نظر درباره‌ی کالا ارائه‌ی اطلاعات مشخص و
                                دقیق برای راهنمایی سایر کاربران در فرآیند خرید یک محصول توسط ایشان است.
                       
                                نکات مهم افزودن عکس و ویدیو به نظرات:
                           
                                ثبت یا مشخص بودن شماره تلفن، ‌آدرس، مشخصات شبکه‌های اجتماعی غیرمجاز است.
                             `,
    rulesRegulations = " قوانین و مقررات",
    ticketRegistration = "ثبت تیکت",
    ticketContent = "متن تیکت",
    enterTicketText = "متن تیکت را وارد کنید",
    tickets = "تیکت ها",
    ticket = "تیکت ",
    ticketTitle = "عنوان تیکت",
    subject = "موضوع",
    operation = "عملیات",
    dontHaveAnyTicketsYet = "هنوز هیچ تیکتی ثبت نکرده‌اید.",
    view = "  مشاهده",
    pleaseTypeHere = "لطفا اینجا تایپ کنید...",
    settlementRequest = "درخواست تسویه",
    areYouSureAboutYourRequest = "آیا از درخواست خود اطمینان دارید ؟",
    submitRequest = "ثبت درخواست",
    cancellation = "انصراف",
    noteSettlementRequest = "توجه ! برای درخواست تسویه باید شماره شبا خود را ثبت کنید ، توجه کنید که شماره شبا باید به نام خودتان باشد",
    registerIbanNumber = "ثبت شماره شبا",
    youHaveOpenSettlementRequest = "شما یک درخواست تسویه ی باز دارید!",
    notificationSetting = "تنظیمات اطلاعیه ها",
    sms = "پیامک",
    enterTheTicketTitle = "عنوان تیکت را وارد کنید",
    customerService = "خدمات مشتریان",
    financial = "مالی",
    warehouse = "انبار",
    areYouLoggingOutOfYourAccount = "        از حساب کاربری خارج میشوید؟",
    byLoggingOutYouWillNotAccessShopping = "با خروج از حساب کاربری به سبد خرید فعلی‌تان دسترسی نخواهید داشت. هر وقت بخواهید می‌توانید مجددا وارد شوید و خریدتان را ادامه دهید.",
    exitAccount = "خروج از حساب",
    recommendBuyingProduct = "  خرید این محصول را توصیه میکنم",
    dontRecommendBuyingProduct = "خرید این محصول را توصیه نمیکنم",
    notSure = "مطمئن نیستم",
    selectAddress = "انتخاب آدرس",
    requiredSelectAddress = "انتخاب آدرس الزامی می باشد!",
    voucherOrGiftCard = "کد تخفیف یا کارت هدیه",
    enterNumberOrEmailInvitation = "شماره یا ایمیل معرف خود را وارد کنید",
    filter = "فیلتر",
    default = "پیش فرض",
    deprecated = "منقضی شده",
    sort = "مرتب سازی",
    oldest = "قدیمی ترین",
    newest = "جدید ترین",
    open = "باز",
    close = "بسته",
    underReview = "در حال بررسی",
    answered = "پاسخ داده شده",
    userAnswer = "پاسخ کاربر",
    keep = "نگه داشته شده"
}

export enum StaticWordEnum {
    resendTheVerificationCode = "ارسال مجدد کد تایید",
    password = "رمز عبور",
    back = "بازگشت",
    introTextGetMobileOrEmail = "برای ورود به حساب کاربری خود شماره همراه یا ایمیل خود را وارد نمایید",
    welcome = " سلام الانزایی عزیز",
    loginWithPassword = ' ورود با رمز عبور',
    continue = 'ادامه',
    confirm = 'تایید',
    accept = 'ثبت',
    acceptForm = 'تایید',
    changeNumber = ' تغییر شماره',
    sentOtpMessage = ' برای ادامه یک کد اعتبار سنجی به شما ارسال گردیده است که باید در زیر وارد نمایید',
    EnterMobileOrEmail = 'شماره موبایل یا ایمیل',
    getCode = 'کد دریافتی',
    searchProducts = 'جستجو محصولات',
    EnterPhone = "شماره تلفن همراه",
    registeredBeforeInfo = 'شما قبلا ثبت نام کرده اید برای ادامه رمز عبور خود را وارد کنید',
    forgotPass = 'رمز عبورم را فراموش کرده ام',
    rememberAuth = 'مرا به خاطر بسپار'
}

export enum StatusFormEnum {
    request = 'request',
    otp = 'otp',
    password = 'password',
}

export enum ErrorEnum {
    notFoundPage = "صفحه ی مورد نظر یافت نشد",
    mayCheckWrongPage = "ممکن است نشانی صفحه اشتباه وارد شده باشد",
    backToHome = " بازگشت به صفحه اصلی"
}

export const aboutUs = {
    main_title: 'درباره الانزا',
    href: '',
    description: `فروشگاه لوازم آرایشی و بهداشتی الانزا مکانی است برای همه افراد تا بتوانند با اطمینان کامل، مناسب‌ترین و بهترین محصولات انواع برندهای موجود در بازار را تهیه کنند. همچنین الانزا در جهت احترام به حقوق مصرف کنندگان امکان خرید از فروشگاه‌های متعدد با محصولات متنوع‌تر را نیز، برای شما فراهم آورده است.`
}
